import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const WORK_HOUR_ENDPOINT = '/work-hours';

export class WorkHourService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE REGISTROS DE HORAS TRABAJADAS
     * @EN GETS THE LIST OF WORK HOUR REGISTERS
     * 
     * @param filters
     */
    // -------------------------------------------------------------------------------------------------------------
    listWorkHours = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: WORK_HOUR_ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UN REGISTRO DE HORA TRABAJADA POR SU ID
     * @EN GETS A WORK HOUR REGISTER BY ITS ID
     * 
     * @param workHourId
     */
    // -------------------------------------------------------------------------------------------------------------
    getWorkHourById = async (workHourId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: WORK_HOUR_ENDPOINT + '/get',
            data: { id: workHourId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UN REGISTRO DE HORA TRABAJADA
     * @EN CREATES A WORK HOUR REGISTER
     * 
     * @param workHour
     */
    // -------------------------------------------------------------------------------------------------------------
    createWorkHour = async (workHour: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: WORK_HOUR_ENDPOINT + '/create',
            data: workHour,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA UN REGISTRO DE HORA TRABAJADA
     * @EN EDITS A WORK HOUR REGISTER
     * 
     * @param workHour
     */
    // -------------------------------------------------------------------------------------------------------------
    editWorkHour = async (workHour: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: WORK_HOUR_ENDPOINT + '/edit',
            data: workHour,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UN REGISTRO DE HORA TRABAJADA
     * @EN DELETES A WORK HOUR REGISTER
     * 
     * @param workHourId
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteWorkHour = async (workHourId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: WORK_HOUR_ENDPOINT + '/delete',
            data: { id: workHourId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA VARIOS REGISTROS DE HORA TRABAJADA
     * @EN DELETES MULTIPLE WORK HOUR REGISTERS
     * 
     * @param workHourIds
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiWorkHours = async (workHourIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: WORK_HOUR_ENDPOINT + '/delete-multi',
            data: { ids: workHourIds }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES IMPORTA HORAS DE TRABAJO DESDE UN EXCEL
     * @EN IMPORTS WORK HOURS FROM AN EXCEL FILE
     */
    // -------------------------------------------------------------------------------------------------------------
    importExcel = async (formData: FormData) => {
        this.response = await this.makeRequest(
            {
                method: "POST",
                url: WORK_HOUR_ENDPOINT + "/import",
                data: formData,
                headers: {},
            },
            true
        );
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}